import { JwLoaderComponent } from '@app/features/loader-ui/jw-loader.component';
import { LoaderUiComponent } from './loader-ui.component';
import { NgModule } from '@angular/core';
import { LoaderUiService } from './loader-ui.service';

@NgModule({
	imports: [
	],
	declarations: [
        LoaderUiComponent,
        JwLoaderComponent,
	],
	exports: [
        LoaderUiComponent,
        JwLoaderComponent,
	],
	providers: [
        LoaderUiService,
	],
	entryComponents: [
	],
})
export class LoaderUiModule { }
